export default "__VITE_ASSET__8rqiOD3b__"